module.exports = __webpack_public_path__ + "static/media/md-arrow-forward.962cbfb7.svg";